var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "a",
        {
          attrs: { id: "helpToolTip" },
          on: {
            click: function($event) {
              return _vm.openHelpMessageToolTip()
            }
          }
        },
        [_vm._v("Help")]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: { triggers: "hover focus", target: "helpToolTip", title: "" }
        },
        [
          _c("p", [
            _c("span", { staticClass: "question-mark" }, [_vm._v("?")]),
            _vm._v(
              " Use the yellow Help Icons to learn more about this website."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Not every page has Help Icons. You can start on the auction search form to see example help icons."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              'Click on the "Hide Help" link at the top of the page to hide the help icons.'
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              'For more help, use the "Report problem" link at the bottom of any page to contact technical support, or use the "Contact" link to contact sales or administative staff. '
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dd61f47", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd61f47","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/HelpToolTip.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7dd61f47","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/HelpToolTip.vue
// module chunks = 0